/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final price`)
};

const es_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio final`)
};

const de_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpreis`)
};

const nl_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eindprijs`)
};

const fr_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix final`)
};

const it_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo finale`)
};

const pt_br2_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço final`)
};

const pt_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço final`)
};

const ja_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終価格`)
};

const zh_pct_result_final_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最终价格`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_result_final_price = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_result_final_price(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_result_final_price", locale)
	if (locale === "en") return en_pct_result_final_price(inputs)
	if (locale === "es") return es_pct_result_final_price(inputs)
	if (locale === "de") return de_pct_result_final_price(inputs)
	if (locale === "nl") return nl_pct_result_final_price(inputs)
	if (locale === "fr") return fr_pct_result_final_price(inputs)
	if (locale === "it") return it_pct_result_final_price(inputs)
	if (locale === "pt-BR") return pt_br2_pct_result_final_price(inputs)
	if (locale === "pt") return pt_pct_result_final_price(inputs)
	if (locale === "ja") return ja_pct_result_final_price(inputs)
	return zh_pct_result_final_price(inputs)
};